(function () {
  const path = window.location.pathname.replace(/\/$/, '');

  const mochiBadgeProducts = [
    '/products/8-piece-square-dish-set',
    '/products/8-piece-round-dish-set',
    '/products/12-piece-round-dish-set'
  ];

  const delayedShippingProducts = [
    '/products/8-piece-square-dish-set'
  ];

  const expirationDate = new Date('2026-08-24T23:59:00-04:00');

  /*
   * NEW BADGE
   * All three Mochi PDPs
   */
  function addMochiBadge() {
    if (!mochiBadgeProducts.includes(path)) return;

    const mochiInputs = document.querySelectorAll(
      'input[name="Color"][value="Mochi"]'
    );

    mochiInputs.forEach(function (mochiInput) {
      const mochiItem = mochiInput.closest('li');

      if (!mochiItem) return;

      mochiItem.classList.add('mochi-color-option');

      if (!mochiItem.querySelector('.mochi-new-badge')) {
        const badge = document.createElement('span');

        badge.className = 'mochi-new-badge';
        badge.textContent = 'NEW';

        mochiItem.prepend(badge);
      }
    });
  }

  /*
   * PDP SHIPPING MESSAGE
   * Square set + Mochi only
   * Expires August 24, 2026 at 11:59 PM ET
   */
  function setupShippingMessage() {
    if (!delayedShippingProducts.includes(path)) return;
    if (new Date() > expirationDate) return;

    const selectedColor = document.querySelector(
      'input[name="Color"]:checked'
    );

    if (!selectedColor) return;

    const formId = selectedColor.getAttribute('form');

    const productForm = formId
      ? document.getElementById(formId)
      : selectedColor.closest('form');

    if (!productForm) return;

    const buttons = productForm.querySelector('.product-form__buttons');

    if (!buttons) return;

    let shippingMessage = productForm.querySelector(
      '.mochi-shipping-message'
    );

    if (!shippingMessage) {
      shippingMessage = document.createElement('div');

      shippingMessage.className = 'mochi-shipping-message';
      shippingMessage.textContent = 'Ships in 3–5 business days';

      buttons.before(shippingMessage);
    }

    shippingMessage.hidden =
      selectedColor.value.trim().toLowerCase() !== 'mochi';
  }

  /*
   * STICKY BUY BUTTON SHIPPING MESSAGE
   * Square set + Mochi only
   * Expires August 24, 2026 at 11:59 PM ET
   */
  function updateStickyShippingMessage() {
    if (!delayedShippingProducts.includes(path)) return;
    if (new Date() > expirationDate) return;

    const stickyBuyButton = document.querySelector(
      'sticky-buy-button'
    );

    if (!stickyBuyButton) return;

    const variantTitle = stickyBuyButton.querySelector(
      'sticky-variant-title'
    );

    const price = stickyBuyButton.querySelector(
      '[id^="StickyPrice-"]'
    );

    if (!variantTitle || !price) return;

    const isMochi =
      variantTitle.textContent.trim().toLowerCase() === 'mochi';

    let shippingMessage = stickyBuyButton.querySelector(
      '.mochi-shipping-message'
    );

    if (isMochi) {
      if (!shippingMessage) {
        shippingMessage = document.createElement('div');

        shippingMessage.className = 'mochi-shipping-message';
        shippingMessage.textContent = 'Ships in 3–5 business days';

        price.after(shippingMessage);
      }
    } else if (shippingMessage) {
      shippingMessage.remove();
    }
  }

  /*
   * REBUY CART SHIPPING MESSAGE
   * Square set + Mochi only
   * Expires August 24, 2026 at 11:59 PM ET
   */
  function updateRebuyShippingMessage() {
    if (new Date() > expirationDate) return;

    const cartItems = document.querySelectorAll(
      '.rebuy-cart__flyout-item.product-8-piece-square-dish-set'
    );

    cartItems.forEach(function (cartItem) {
      const variantTitle = cartItem.querySelector(
        '.rebuy-cart__flyout-item-variant-title'
      );

      if (!variantTitle) return;

      const isMochi =
        variantTitle.textContent.trim().toLowerCase() === 'mochi';

      let shippingMessage = cartItem.querySelector(
        '.mochi-cart-shipping-message'
      );

      if (isMochi) {
        if (!shippingMessage) {
          shippingMessage = document.createElement('div');

          shippingMessage.className = 'mochi-cart-shipping-message';
          shippingMessage.textContent = 'Ships in 3–5 business days';

          variantTitle.after(shippingMessage);
        }
      } else if (shippingMessage) {
        shippingMessage.remove();
      }
    });
  }

  /*
   * INITIAL RUN
   */
  function initMochiLaunch() {
    addMochiBadge();
    setupShippingMessage();
    updateStickyShippingMessage();
    updateRebuyShippingMessage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMochiLaunch);
  } else {
    initMochiLaunch();
  }

  /*
   * WATCH FOR THEME / REBUY / VARIANT RERENDERS
   */
  const observer = new MutationObserver(function () {
    addMochiBadge();
    setupShippingMessage();
    updateStickyShippingMessage();
    updateRebuyShippingMessage();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /*
   * WATCH COLOR CHANGES
   */
  document.addEventListener('change', function (event) {
    if (event.target.matches('input[name="Color"]')) {
      setupShippingMessage();
      updateStickyShippingMessage();
    }
  });
})();